import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBg: "#05416D",
            defaultHoverColor: "#FFFFFF",
            defaultActiveBg: "#052147",
            defaultActiveColor: "#FFFFFF",
          },
        },
      }}
    >
      <App />
    </ConfigProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
